// extracted by mini-css-extract-plugin
export default {"grid1":"auftragterminieren_grid1__M2BHY"};